import { useTranslation } from 'react-i18next';
import { useIdentityAuth } from '@auth/IdentityAuthContext';
import styles from '@styles/AppRoutes.module.css';

const ErrorPage: React.FC = () => {
  const { t } = useTranslation();
  const { logout } = useIdentityAuth();

  return (
    <div className={styles.errorContainer} role='alert'>
      <h2>{t('error.oops')}</h2>
      <p>{t('error.tryRefreshing')}</p>
      <button
        className={styles.logoutButton}
        type='button'
        onClick={() => logout()}
      >
        {t('auth.logout')}
      </button>
    </div>
  );
};

export default ErrorPage;
